module.exports = __webpack_public_path__ + "img/cd-logo-black2x.55fce5f5.png";